import { Box } from "@repo/ui/core";
import { Outlet } from "react-router";
import { Footer } from "@components/Footer";
import { CustomerProvider, useCustomer } from "@contexts/CustomerContext";
import { ParkingLotProvider } from "@contexts/ParkingLotContext";
import { OnsiteNav } from "@components/OnsiteNav";

function LayoutInner() {
  const customer = useCustomer();

  return (
    <ParkingLotProvider customerId={customer.id}>
      <Box
        mih="100vh"
        style={{
          display: "flex",
          flexDirection: "column",
          background: "var(--mantine-color-dark-9)",
        }}
      >
        <OnsiteNav />
        <Box
          h={2}
          style={{
            background: "linear-gradient(90deg, var(--customer-accent), var(--customer-secondary))",
          }}
        />
        <Box style={{ flex: 1 }}>
          <Outlet />
        </Box>
        <Footer />
      </Box>
    </ParkingLotProvider>
  );
}

export function OnsiteLayout() {
  return (
    <CustomerProvider>
      <LayoutInner />
    </CustomerProvider>
  );
}
